module.exports = __webpack_public_path__ + "static/img/door-2.5059c226.png";